import React from "react";

const InputFileMultiple = ({onChange, isClear = false}) => {

    const ref = React.createRef();

    React.useEffect(() => {
        ref.current.value = null;
    }, [isClear])

    return <label
        className="btn bg-slate-150 font-medium text-slate-800 hover:bg-slate-200 focus:bg-slate-200 active:bg-slate-200/80 dark:bg-navy-500 dark:text-navy-50 dark:hover:bg-navy-450 dark:focus:bg-navy-450 dark:active:bg-navy-450/90"
    >
        <input
            ref={ref}
            onChange={onChange}
            type="file"
            multiple={true}
            accept={".jpg,.png,.jpeg"}
            className="pointer-events-none absolute inset-0 h-full w-full opacity-0"
        />
        <div className="flex items-center space-x-2">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                />
            </svg>
            <span>Выберите файл</span>
        </div>
    </label>

}

export default InputFileMultiple;
